import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { GaugeCircle, Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setOk(true);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface flex flex-col justify-center items-center p-5" data-testid="forgot-page">
      <Link to="/" className="flex items-center gap-2 mb-8">
        <div className="w-9 h-9 rounded-lg bg-navy-900 flex items-center justify-center">
          <GaugeCircle className="w-5 h-5 text-orange-500" />
        </div>
        <span className="font-bold text-lg">EntryBook</span>
      </Link>
      <div className="w-full max-w-md bg-white rounded-2xl shadow-card border border-navy-100 p-8">
        <h1 className="text-2xl font-semibold mb-1">Forgot password</h1>
        <p className="text-sm text-navy-500 mb-5">We'll send a reset link to your inbox.</p>
        {ok ? (
          <div className="rounded-md bg-success/10 border border-success/30 text-success-700 px-3 py-3 text-sm" data-testid="forgot-ok">
            <div className="flex items-center gap-2 font-medium text-navy-900">
              <Mail className="w-4 h-4" /> If an account with that email exists, you'll receive a reset link shortly.
            </div>
            <div className="mt-2 text-xs text-navy-600">
              Please also check your spam folder.
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="eb-label">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="eb-input" data-testid="forgot-email-input" />
            </div>
            {err && <div className="rounded-md bg-danger/10 border border-danger/30 text-danger text-sm px-3 py-2">{err}</div>}
            <button type="submit" disabled={loading} className="btn-accent w-full" data-testid="forgot-submit-btn">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <div className="mt-6 text-sm text-center">
          <Link to="/login" className="text-orange-600 hover:underline">Back to login</Link>
        </div>
      </div>
    </div>
  );
}
